import React from 'react';
import { Reveal } from '../Reveal';
import { LinkButton } from '../Button';
import { founder } from '../../data/team';
export function FounderNote() {
  return <section className="bg-cream" aria-label="A note from the founder" data-id="element-35" data-mp="3rx3ec10e0p0g">
      <div className="mx-auto w-full max-w-shell px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-36" data-mp="3d3qhazzdnmia">
        <Reveal className="grid items-center gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-37" data-mp="3i21r5apo9x0i">
          <div className="lg:col-span-5" data-id="element-38" data-mp="9l6xmlurloz3">
            <img src={founder.portrait} alt={`${founder.name}, founder of MeraBucket, at his desk`} className="h-[22rem] w-full rounded-sm border border-line object-cover object-top shadow-card sm:h-[26rem]" data-id="element-39" data-mp="9njojoii39oa" />
          </div>

          <figure className="lg:col-span-7" data-id="element-40" data-mp="4t5oh8sw8eda">
            <span className="font-sans text-overline font-semibold uppercase text-gold-dark" data-id="element-41" data-mp="skb0tdzmkoiu">
              A note from the founder
            </span>
            <blockquote className="mt-6" data-id="element-42" data-mp="xcm3golr2of3">
              <p className="font-serif text-[1.6rem] leading-[1.35] text-charcoal sm:text-[1.95rem]" data-id="element-43" data-mp="22eobd2ci9yov">
                “I spent fifteen years in public and private markets watching families outside the
                metros be sold products rather than advised. MeraBucket is the firm I wished those
                families had — <em className="italic text-gold-dark" data-id="element-44" data-mp="27d7xp3v0hchr">paid by them, and by no one
                else</em>.”
              </p>
            </blockquote>
            <figcaption className="mt-7 border-t border-line pt-6" data-id="element-45" data-mp="2l3be3e77mbza">
              <p className="font-medium text-charcoal" data-id="element-46" data-mp="2g51i51dnv7cm">{founder.name}</p>
              <p className="mt-1 text-sm text-charcoal-600" data-id="element-47" data-mp="2v3287eruyoyu">
                {founder.role} · {founder.location}
              </p>
            </figcaption>
            <dl className="mt-8 grid max-w-lg grid-cols-3 gap-6 border-t border-line pt-6" data-id="element-48" data-mp="2q50pww29atof">
              <div data-id="element-49" data-mp="10pujm4uh79ln">
                <dt className="text-xs uppercase tracking-wider text-charcoal-400" data-id="element-50" data-mp="10rf7jbmabuaj">Experience</dt>
                <dd className="mt-1.5 font-serif text-xl text-charcoal" data-id="element-51" data-mp="vsaz4n76q0l9">15+ years</dd>
              </div>
              <div data-id="element-52" data-mp="1lgq2b1mwbc1k">
                <dt className="text-xs uppercase tracking-wider text-charcoal-400" data-id="element-53" data-mp="1pfp3qc9f4qo9">Markets</dt>
                <dd className="mt-1.5 font-serif text-xl text-charcoal" data-id="element-54" data-mp="1ufbhqnx2may4">Public &amp; private</dd>
              </div>
              <div data-id="element-55" data-mp="1zeo6xfbezu3v">
                <dt className="text-xs uppercase tracking-wider text-charcoal-400" data-id="element-56" data-mp="1zexvcygt9t7g">Registration</dt>
                <dd className="mt-1.5 font-serif text-xl text-charcoal" data-id="element-57" data-mp="24cg6mviawkim">SEBI RIA</dd>
              </div>
            </dl>
            <div className="mt-8" data-id="element-58" data-mp="28d04606sdq5a">
              <LinkButton to="/about" variant="outline" data-id="element-59" data-mp="2d5jk33sy4xd9">
                Read the founding story
              </LinkButton>
            </div>
          </figure>
        </Reveal>
      </div>
    </section>;
}